import { render, staticRenderFns } from "./Curriculo_Main.vue?vue&type=template&id=a394fd80&scoped=true"
import script from "./Curriculo_Main.vue?vue&type=script&lang=js"
export * from "./Curriculo_Main.vue?vue&type=script&lang=js"
import style0 from "./Curriculo_Main.vue?vue&type=style&index=0&id=a394fd80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a394fd80",
  null
  
)

export default component.exports